import { render, staticRenderFns } from "./taskModal.vue?vue&type=template&id=9fe0838e&scoped=true"
import script from "./taskModal.vue?vue&type=script&lang=js"
export * from "./taskModal.vue?vue&type=script&lang=js"
import style0 from "./taskModal.vue?vue&type=style&index=0&id=9fe0838e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe0838e",
  null
  
)

export default component.exports